import { useNavigate } from "react-router-dom";

import AVIcon from "../../../components/icons/AllVoicedIcons";
import {
  ApplicationButton,
  ApplicationSectionHeader
} from "../../../components/application";

export default function AssignedWorkDashboardEntry({
  headingLevel = 2,
  title = "Participate",
  titleId = "dashboard-participate-title",
  description = "Join live sessions or access your projects.",
  actionLabel = "Open Participate",
  icon = "inbox",
  to = "/app/participate"
} = {}) {
  const navigate = useNavigate();

  return (
    <section
      aria-labelledby={titleId}
      className="av-dashboard-assigned-work-entry"
    >
      <div className="av-dashboard-assigned-work-entry__layout">
        <div
          aria-hidden="true"
          className="av-app-icon-badge"
        >
          <AVIcon icon={icon} size={24} />
        </div>

        <div className="av-dashboard-assigned-work-entry__content">
          <ApplicationSectionHeader
            headingLevel={headingLevel}
            title={title}
            titleId={titleId}
            variant="compact"
          />

          <div className="av-dashboard-assigned-work-entry__body">
            <p>{description}</p>

            <ApplicationButton
              className="av-dashboard-assigned-work-entry__action"
              onClick={() => navigate(to)}
              variant="secondary"
            >
              {actionLabel}
            </ApplicationButton>
          </div>
        </div>
      </div>
    </section>
  );
}
